const routes = [
    '/',
    '/countries',
    '/banks',
];

export default routes;